module.exports = __webpack_public_path__ + "static/media/Batman-slapping-Robin-Meme-Blank.7cc2b8be.jpg";